import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './AboutValuesSection.scss';

const AboutValuesSection = () => {
    const { t } = useTranslation();
    const [openValue, setOpenValue] = useState(null);

    const values = [
        { id: 1, title: t('about_value_unity'), description: t('about_value_unity_desc') },
        { id: 2, title: t('about_value_dedication'), description: t('about_value_dedication_desc') },
        { id: 3, title: t('about_value_excellence'), description: t('about_value_excellence_desc') },
        { id: 4, title: t('about_value_relevance'), description: t('about_value_relevance_desc') },
        { id: 5, title: t('about_value_christ_centeredness'), description: t('about_value_christ_centeredness_desc') }
    ];

    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    const toggleValue = (id) => {
        setOpenValue(openValue === id ? null : id);
    };

    return (
        <section className="about-values">
            <div className="about-values__container">
                
                <motion.h2 className="about-values__main-title" {...fadeUp(0, 1.1)}>
                    {t('about_values_title')}
                </motion.h2>

                <div className="about-values__columns">
                    
                    <motion.div className="about-values__left" {...fadeUp(0.15)}>
                        <div className="about-values__church">
                            <span className="about-values__church-text">{t('about_values_church_label')}</span>
                        </div>
                    </motion.div>

                    <motion.div className="about-values__right" {...fadeUp(0.3)}>
                        <div className="about-values__list">
                            {values.map((value) => (
                                <div key={value.id} className="about-values__item">
                                    <div 
                                        className="about-values__header"
                                        onClick={() => toggleValue(value.id)}
                                    >
                                        <h4 className="about-values__title">{value.title}</h4>
                                        <span className="about-values__icon">
                                            {openValue === value.id ? '−' : '+'}
                                        </span>
                                    </div>
                                    
                                    {openValue === value.id && (
                                        <div className="about-values__description">
                                            <p>{value.description}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default AboutValuesSection;